import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Utils } from '../enums/utils.enum';
import { ErrorPipe } from '../shared/pipes/error.pipe';
import { HelperService } from './helper.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private helperService: HelperService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(Utils.InterceptorSkipHeader)) {
      const headers = req.headers.delete(Utils.InterceptorSkipHeader);
      return next.handle(req.clone({ headers }));
    }

    return next.handle(req).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          /** Logic for good response */
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          try {
            const errorMsg = this.buildErrorMsg(err.error, err.status);
            if (errorMsg) {
              this.helperService.showAlertSnackbar(errorMsg);
            }
          } catch (e) {
            console.error(err);
          }
        }
        return throwError(err);
      })
    );
  }

  buildErrorMsg(data: any, status: number): string {
    return status !== 500 ? new ErrorPipe().transform(data) : '';
  }
}
